var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{attrs:{"text":_vm.$t('baselayer')}},_vm._l((_vm.items),function(item,index){return _c('b-dropdown-item',{key:index,attrs:{"index":index,"item":item},on:{"click":function($event){return _vm.switchBaseLayer(item.code)}}},[_vm._v(" "+_vm._s(item.name)+" "),(item.active)?_c('span',[_vm._v("*")]):_vm._e()])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }